<template lang="pug">
v-container.py-8.pl-4
  template(v-if="isFetching && !fetchingData")
    v-row(no-gutters)
      v-col
        v-skeleton-loader(type="article")
      v-col
        v-skeleton-loader(type="image")
  template(v-else)
    automation-setup(:fetchingData="fetchingData")
</template>

<script>
import AutomationSetup from '@/components/review/settings/AutomationSetup.vue'

export default {
  name: 'AutomationTab',
  components: {
   AutomationSetup,
  },
  props: {
    isFetching: {
      type: Boolean,
    },
    fetchingData: {
      type: Object,
      default: null,
    }
  },
}
</script>

<style scoped>
</style>